import {
  Measure
} from '../../common/measure';

require('./context-menu.component.scss');

/*@ngInject*/
class ContextMenuController {
  constructor(
    $scope,
    $element,
    $timeout,
    PermissionService,
    RouterService,
    CurrentModelService,
  ) {
    this.CurrentModelService = CurrentModelService;
    this.permission = PermissionService;
    this.router = RouterService;
    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    // this.cut = this.CurrentModelServ.model.getCellFilter(this.dimension, this.cell);
    this.show = {
      viewEvents: true,
      filterValue: true,
      cutEdit: this.permission.admin && this.permission.policies && (this.dimension != 'analytics_filter@name:name'),
      filterEdit: !this.permission.admin && this.permission.policies,
    };
  }

  viewEvents() {
    this.$scope.drilldownCell({
      drill: this.dimension,
      cell: this.cell
    });
  }

  filterValue() {
    this.$scope.drilldownCell({
      drill: this.dimension,
      cell: this.cell,
      currMode: true,
    });
    // this.router.drilldownFilter2(this.dimension, this.value, this.value, this.router.mode);
  }

  cutEdit() {
    const cut = this.CurrentModelService.model.getCellFilter(this.dimension, this.cell);
    this.router.changeCut(cut.dimension, cut.value, 'cut-edit');
  }

  filterEdit() {
    const cut = this.CurrentModelService.model.getCellFilter(this.dimension, this.cell);
    this.router.changeCut(cut.dimension, cut.value, 'filter-edit');
  }
}

export function ContextMenuComponent() {
  return {
    template: require('./context-menu.component.html'),
    restrict: 'A',
    scope: {
      drilldownCell: '&',
    },
    bindToController: {
      dimension: '<',
      cell: '<',
      // drilldownCell: '&',
    },
    transclude: true,
    controller: ContextMenuController,
    controllerAs: '$ctrl',
  };
}



// WEBPACK FOOTER //
// ./src/stat/context-menu/context-menu.component.js